var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "ul",
      { staticClass: "steps is-narrow is-centered has-content-centered" },
      [
        _c(
          "li",
          {
            staticClass: "steps-segment",
            class: {
              "is-active": _vm.currentStep === _vm.steps.CreateAssign.id,
            },
          },
          [
            _vm._m(0),
            _c("div", { staticClass: "steps-content" }, [
              _c("p", { staticClass: "heading" }, [
                _vm._v(
                  "Create" +
                    _vm._s(_vm.ecomType !== "audanet" ? `/Assign` : "") +
                    " Quote"
                ),
              ]),
            ]),
          ]
        ),
        _c(
          "li",
          {
            staticClass: "steps-segment",
            class: {
              "is-active": _vm.currentStep === _vm.steps.SelectInsurer.id,
            },
          },
          [_vm._m(1), _vm._m(2)]
        ),
        _c(
          "li",
          {
            staticClass: "steps-segment has-gaps",
            class: {
              "is-active": _vm.currentStep === _vm.steps.UpdateCustomer.id,
            },
          },
          [_vm._m(3), _vm._m(4)]
        ),
        _vm.steps.OverwriteVehicle.enabled
          ? _c(
              "li",
              {
                staticClass: "steps-segment has-gaps",
                class: {
                  "is-active":
                    _vm.currentStep === _vm.steps.OverwriteVehicle.id,
                },
              },
              [_vm._m(5), _vm._m(6)]
            )
          : _vm._e(),
      ]
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.currentStep === _vm.steps.CreateAssign.id,
            expression: "currentStep === steps.CreateAssign.id",
          },
        ],
        staticClass: "box",
      },
      [
        _c("load-quote-create-step", {
          attrs: { "ecom-type": _vm.ecomType },
          model: {
            value: _vm.value,
            callback: function ($$v) {
              _vm.value = $$v
            },
            expression: "value",
          },
        }),
      ],
      1
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.currentStep === _vm.steps.SelectInsurer.id,
            expression: "currentStep === steps.SelectInsurer.id",
          },
        ],
        staticClass: "box",
      },
      [
        _c("load-quote-insurer-step", {
          attrs: {
            "insurer-name": _vm.value.insurerName,
            "ecom-type": _vm.ecomType,
            "enable-ecom-type-selection": _vm.enableEcomTypeSelection,
          },
          model: {
            value: _vm.value,
            callback: function ($$v) {
              _vm.value = $$v
            },
            expression: "value",
          },
        }),
      ],
      1
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.currentStep === _vm.steps.UpdateCustomer.id,
            expression: "currentStep === steps.UpdateCustomer.id",
          },
        ],
        staticClass: "box",
      },
      [
        _c("load-quote-customer-step", {
          attrs: { "ecom-type": _vm.ecomType },
          model: {
            value: _vm.value,
            callback: function ($$v) {
              _vm.value = $$v
            },
            expression: "value",
          },
        }),
      ],
      1
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.currentStep === _vm.steps.OverwriteVehicle.id &&
              _vm.steps.OverwriteVehicle.enabled,
            expression:
              "currentStep === steps.OverwriteVehicle.id && steps.OverwriteVehicle.enabled",
          },
        ],
        staticClass: "box",
      },
      [
        _c("load-quote-vehicle-step", {
          model: {
            value: _vm.value,
            callback: function ($$v) {
              _vm.value = $$v
            },
            expression: "value",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "steps-marker" }, [
      _c("span", { staticClass: "icon" }, [
        _c("i", { staticClass: "mdi mdi-lead-pencil" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "steps-marker" }, [
      _c("span", { staticClass: "icon" }, [
        _c("i", { staticClass: "mdi mdi-shield-outline" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "steps-content" }, [
      _c("p", { staticClass: "heading" }, [_vm._v("Select Insurer")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "steps-marker" }, [
      _c("span", { staticClass: "icon" }, [
        _c("i", { staticClass: "mdi mdi-account" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "steps-content" }, [
      _c("p", { staticClass: "heading" }, [_vm._v("Update Customer")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "steps-marker" }, [
      _c("span", { staticClass: "icon" }, [
        _c("i", { staticClass: "mdi mdi-car-back" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "steps-content" }, [
      _c("p", { staticClass: "heading" }, [_vm._v("Overwrite Vehicle")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }